import React from "react";
import {Link} from "react-router-dom";
import SEO from "./SEO";

const NotFound = () => {
	return (
		<>
			<SEO
				title="Sayfa Bulunamadı (404) · Proteam Yönetim"
				description="Aradığınız sayfa bulunamadı. Ana sayfaya dönerek devam edebilirsiniz."
				path="/404"
				noindex
			/>
			<section className="not-found">
				<div className="not-found-inner">
					<span className="section-eyebrow">404</span>
					<h1 className="section-title">Sayfa bulunamadı</h1>
					<p className="section-lead">
						Aradığınız sayfa kaldırılmış, taşınmış ya da hiç var olmamış
						olabilir. Aşağıdaki bağlantıdan ana sayfaya dönebilirsiniz.
					</p>
					<div className="not-found-actions">
						<Link to="/" className="btn btn-primary">Ana sayfaya dön</Link>
						<Link to="/iletisim" className="btn btn-link">Bize ulaşın</Link>
					</div>
				</div>
			</section>
		</>
	);
};

export default NotFound;
